import { AutomationVariable } from './../../entities/automation/AutomationAction';
import { Endpoint } from '../endpoint';
import { AutomationTrigger, AutomationAction, AutomationActionInput } from '@business/entities/automation';
import { AutomationResponse, AutomationId } from '@business/entities/automation';

export function fetchTriggers() {
  return Endpoint.get<AutomationTrigger[]>(`@gc/automation/triggers`);
}

export function fetchActions() {
  return Endpoint.get<AutomationAction[]>(`@gc/automation/actions`);
}

export function fetchActionInputs(action: string, prevNodes: string[]) {
  return Endpoint.get<{ inputs: AutomationActionInput[]; variables: AutomationVariable[] }>(`@gc/automation/action-inputs`, {
    params: { action, prevNodes },
  });
}

export function fetchAutomations() {
  return Endpoint.get<AutomationResponse[]>(`@gc/automation`);
}

export function fetchAutomation(id: AutomationId) {
  return Endpoint.get<AutomationResponse>(`@gc/automation/automation/${id}`);
}

export function createAutomation(data: Partial<AutomationResponse>) {
  return Endpoint.post<AutomationResponse>(`@gc/automation/create`, { data });
}

export function updateAutomation(id: AutomationId, data: Partial<AutomationResponse>) {
  return Endpoint.post<AutomationResponse>(`@gc/automation/${id}`, { data });
}

export function deleteAutomation(AutomationId: AutomationId) {
  return Endpoint.delete<void>(`@gc/automation/${AutomationId}`);
}
